import MatchLogTypeIcon from "features/matchLog/components/MatchLogTypeIcon";
import type {
  MatchLogEventType,
  MatchLogGoalOutcome,
  MatchLogTimeKind,
} from "features/matchLog/types";
import type { PlayerTimelineSummaryDTO } from "types/homeTable";

type TimelineDiaryEntry = {
  count: number;
  type: MatchLogEventType;
  goalOutcome?: MatchLogGoalOutcome;
  timeKind?: MatchLogTimeKind;
};

const toCount = (value: number | null | undefined) => value ?? 0;

const buildTimelineDiaryEntries = (
  summary?: PlayerTimelineSummaryDTO | null
): TimelineDiaryEntry[] =>
  [
    {
      count: toCount(summary?.goals),
      type: "goal" as const,
      goalOutcome: "scored" as const,
    },
    {
      count: toCount(summary?.penalties),
      type: "time" as const,
      timeKind: "penalties" as const,
    },
    {
      count: toCount(summary?.yellowCards),
      type: "yellowCard" as const,
    },
    {
      count: toCount(summary?.redCards),
      type: "redCard" as const,
    },
  ].filter((entry) => entry.count > 0);

export const formatTimelineTimeOnField = (summary?: PlayerTimelineSummaryDTO | null) =>
  summary?.timeOnField != null ? `${summary.timeOnField}'` : "-";

export const PlayerTimelineDiary = ({ summary }: { summary?: PlayerTimelineSummaryDTO | null }) => {
  const entries = buildTimelineDiaryEntries(summary);

  return entries.length ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingLeft: "8px",
        flexWrap: "wrap",
        gap: "11px",
        height: "100%",
        minHeight: "26px",
      }}
    >
      {entries.map((entry, entryIndex) => (
        <span
          key={`${entry.type}-${entryIndex}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
            whiteSpace: "nowrap",
          }}
        >
          <MatchLogTypeIcon
            type={entry.type}
            goalOutcome={entry.goalOutcome}
            timeKind={entry.timeKind}
            size={14}
          />
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              height: "14px",
              lineHeight: 1,
            }}
          >
            {entry.count}
          </span>
        </span>
      ))}
    </div>
  ) : (
    <span style={{ display: "inline-block", paddingLeft: "8px" }}>-</span>
  );
};
